import { render, staticRenderFns } from "./ColorsSection.vue?vue&type=template&id=407528f0"
import script from "./ColorsSection.vue?vue&type=script&lang=ts"
export * from "./ColorsSection.vue?vue&type=script&lang=ts"
import style0 from "./ColorsSection.vue?vue&type=style&index=0&id=407528f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports